module.exports = __webpack_public_path__ + "img/r-s.850894f6.png";